import { render, staticRenderFns } from "./BulkProfileCreate.vue?vue&type=template&id=132f7c7b&scoped=true"
import script from "./BulkProfileCreate.vue?vue&type=script&lang=ts"
export * from "./BulkProfileCreate.vue?vue&type=script&lang=ts"
import style0 from "./BulkProfileCreate.vue?vue&type=style&index=0&id=132f7c7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f7c7b",
  null
  
)

export default component.exports